import { connect } from 'react-redux'
import { toggleMute, message } from '../../redux/actions'
import Component from '../component'

/**
 * A prompt to turn on or turn off the sounds.
 */
@connect(state => ({ base: state.base }), { toggleMute, message })
export default class SoundPrompt extends Component {
  /**
   * Sets the global Howler mute state.
   * @param {boolean} mute - Sounds on or off.
   * @param {object} e - Button event object.
   * @returns {boolean}
   */
  setMute = (mute, e) => {
    e.preventDefault()
    e.stopPropagation()

    this.soundTimer && clearTimeout(this.soundTimer)
    this.soundTimer = setTimeout(() => {
      this.props.toggleMute(mute)
      this.props.message(null)
    }, 10)

    return false
  }

  /**
   * Renders a DOM element, displaying a yes or no question to
   * enable sounds.
   * @returns {*}
   */
  render() {
    return (
      <div className="popup-content">
        <div className="popup-message">
          {this.t('soundPrompt.playwithsound')}
        </div>

        <br />

        <div className="buttonContainer two-col">
          <button onClick={e => { this.setMute(true, e) }}>{this.t('soundPrompt.mute')}</button>
          <button onClick={e => { this.setMute(false, e) }}>{this.t('soundPrompt.usesounds')}</button>
        </div>
      </div>
    )
  }
}
